import {
  IconBuildingStore,
  IconCalendar,
  IconHeadset,
  IconHome2,
  IconLogout,
  IconReceipt,
  IconReceiptTax,
  IconSchool,
  IconUser
} from '@tabler/icons'
import Link from 'next/link'

import { Site as SiteType, User as UserType } from '@/types'

export const menuItems = (siteData: SiteType, user: UserType | undefined) =>
  [
    {
      label: 'Minha Conta',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconHome2 size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts',
      description: 'Acesse o menu da minha conta.'
    },
    {
      label: 'Comprar Agora',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconBuildingStore size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/profiles',
      description: 'Acessar lojas para comprar produtos e serviços.'
    },
    {
      label: 'Mensalidades',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconCalendar size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/contract-payments',
      description: 'Pagamentos das mensalidades dos alunos vinculado ao responsável.',
      hidden: !siteData?.hasSchoolManagementConfiguration
    },
    {
      label: 'Meus Pedidos',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconReceipt size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/orders',
      description: 'Acesse notas fiscais, pagamentos, cancelamento e devolução.'
    },
    {
      label: 'Meus Dados',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconUser size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/profile',
      description: 'Altere e mantenha seus dados atualizados.'
    },
    {
      label: 'Meus Alunos',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconSchool size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/students',
      description: 'Alunos vinculado ao responsável.',
      isStaff: false
    },
    {
      label: 'Extrato de Pagamentos',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconReceiptTax size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/payment-statement',
      description: 'Veja o extrato de pagamentos realizados em nossa loja.',
      hidden: !siteData?.hasSchoolManagementConfiguration
    },
    { divider: true },
    { label: 'Site', section: true },
    {
      label: 'Atendimento',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconHeadset size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/help',
      description: undefined
    },
    {
      label: 'Sair',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconLogout size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/logout',
      description: undefined
    }
  ].filter(item => !item.hidden)
